import styled from '@emotion/styled'

import { mediaDown, mediaUp } from '@/styles/media'
import { H3, Text2, Text2Styles } from '@/styles/typography'
import { colors } from '@/styles/theme'
import { withStrong } from '@/styles/mixins'

interface PriceWrapperProps {
  shouldHighlightPrice: boolean
}

export const TileContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  min-width: 360px;
  margin-bottom: 24px;
  height: auto;
  ${mediaUp('md')} {
    padding: 16px;
    margin: 8px;
    max-width: unset;
    height: 100%;
  }
`

export const ImageContainer = styled.div`
  flex: 0 0 40%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mediaUp('md')} {
    flex: 0 0 25%;
  }
`

export const InfoContainer = styled.div`
  flex: 1 1 70%;
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  ${mediaUp('md')} {
    padding-left: 20px;
  }
`

export const PriceAndButton = styled.div`
  display: flex;
  justify-content: space-between;
  justify-content: flex-end;
`

export const AddressWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin: 12px 0 0 0;
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  text-align: left;
  color: #6c7075;
`

export const PriceWrapper = styled.div<PriceWrapperProps>`
  border-radius: 17px;
  background: ${({ shouldHighlightPrice }) =>
    shouldHighlightPrice ? 'rgba(255, 0, 0, 0.12)' : colors.paleGrey};
  display: flex;
  height: 24px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  ${mediaUp('md')} {
    min-width: 68px;
  }
`

export const StyledImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 12px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  ${mediaUp('md')} {
    border-radius: 8px;
    cursor: pointer;
  }
`

export const ParkingTitle = styled(H3)`
  font-size: 14px;
  font-family: Nunito;
  font-weight: 900;
  line-height: 19.1px;
  text-align: left;
  margin-bottom: 10px;

  ${mediaUp('md')} {
    font-size: 21px;
    margin-top: unset;
  }
  
  html[lang^='ar'] & {
    text-align: right; 
    direction: rtl;
  ]
`

export const TagsWrapper = styled.div`
  display: flex;
  margin-bottom: 4px;
  position: relative;

  ${mediaUp('md')} {
    margin-bottom: 16px;
    width: 110%;
    margin-right: 0px;
  }
  ${mediaUp('lg')} {
    margin-bottom: 24px;
    width: unset;
    margin-right: 6px;
  }
`

export const LowestPriceWrapper = styled.div`
  display: inline;
  margin-left: auto;
  text-align: right;
  font-size: 10px;
  font-weight: 600;
  line-height: 14px;
  color: #6c7075;
  margin-bottom: 12px;
  white-space: normal;
`

export const CustomisedText2 = styled.span`
  ${Text2Styles};

  ${withStrong('black')};
`

export const CrossedText2 = styled.span`
  ${Text2}
  font-size: 14px;
  text-decoration: line-through;
  color: ${colors.blueyGrey};
`
export const DoubleColumnRow = styled.div`
  display: grid;
`

export const DistanceInfo = styled.div`
  color: #6c7075;
  font-family: Nunito;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin: 8px 0;
  display: flex;
  align-items: center;
  gap: 4px;
  ${mediaUp('md')} {
    margin: 12px 0;
  }
`

export const ParkingTileMobileReview = styled.div`
  position: absolute;
  display: flex;
  top: 15px;
  width: 13.5%;
  height: 26px;
  border-radius: 6px;
  background-color: white;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 900;
  gap: 5px;
  color: ${colors.gold};
`
